import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildUsedTmvPricingPath, getUsedBaseStylePath, VehicleModel } from 'client/data/models/vehicle-v2';
import {
  buildMMYSubmodelTypeAmountsPath,
  InventoryAggregateEntities,
  InventoryAggregateModel,
} from 'client/data/models/inventory-aggregate';
import { getPriceRangeString } from 'site-modules/shared/utils/price-utils';
import { getUsedVehiclePriceRangeFromTrim } from 'site-modules/shared/utils/core-page/pricing';

function ListPriceRangeUI({
  className = null,
  submodelAmounts = null,
  trim = null,
  usedTmv = null,
  submodelSlug = null,
  valueClassName = null,
  hidePriceLabel = false,
}) {
  const { min, max } = getUsedVehiclePriceRangeFromTrim({ submodelAmounts, trim, usedTmv, submodelSlug });
  const hasPrice = !!(min && max);
  const vehiclePrice = hasPrice && getPriceRangeString(min, max);
  const isInventoryPrice = !!trim || !usedTmv;
  const priceLabel = isInventoryPrice ? `Price${hasPrice && min === max ? '' : ' Range'}` : 'Price Estimate';

  return (
    <div className={classnames(className, { 'd-none': !hasPrice })}>
      {!hidePriceLabel && <Fragment>{priceLabel}:&nbsp;</Fragment>}
      <span className={valueClassName}>{hasPrice ? vehiclePrice : 'Not Available'}</span>
    </div>
  );
}

ListPriceRangeUI.propTypes = {
  submodelAmounts: InventoryAggregateEntities.MMYSubmodelTypeAmounts,
  trim: InventoryAggregateEntities.MMYSubmodelTypeAmountsTrim,
  usedTmv: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  submodelSlug: PropTypes.string,
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  hidePriceLabel: PropTypes.bool,
};

const ListPriceRangeWrapper = connectToModel(ListPriceRangeUI, {
  usedTmv: bindToPath(
    ({ usedBaseStyle, isUnknownZip, submodelAmounts, submodelSlug }) =>
      usedBaseStyle &&
      (isUnknownZip || (submodelAmounts && !get(submodelAmounts, `priceRanges["${submodelSlug}"]`))) &&
      buildUsedTmvPricingPath(get(usedBaseStyle, 'usedDefaultStyle.id')),
    VehicleModel,
    data => ({
      min: get(data, 'ROUGH.Current.totalWithOptions.usedTmvRetail', 0),
      max: get(data, 'OUTSTANDING.Current.totalWithOptions.usedTmvRetail', 0),
    })
  ),
});

export const ListPriceRange = connectToModel(ListPriceRangeWrapper, {
  submodelAmounts: bindToPath(
    ({ params }) => buildMMYSubmodelTypeAmountsPath({ ...params, isUsed: true }),
    InventoryAggregateModel
  ),
  usedBaseStyle: bindToPath(({ params, trim }) => !trim && getUsedBaseStylePath(params), VehicleModel),
});
